import { cn } from '@/lib/utils';

/** Painel escuro do Fairtrade — tons sky/azul (sem âmbar dos Aces). */
export const fairtradeDarkPanelShellClass = cn(
  'relative overflow-hidden rounded-2xl border border-blue-900/60',
  'bg-[#030023] text-sky-50 shadow-lg shadow-black/25 ring-1 ring-sky-400/20'
);

export const fairtradeDarkPanelGradientLayers = (
  <>
    <div
      className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[#000b6a] via-[#030023] to-[#01012e]"
      aria-hidden
    />
    <div
      className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#000b6a]/55 via-[#030023]/90 to-[#01012e]"
      aria-hidden
    />
    <div
      className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-sky-500/[0.08] via-transparent to-indigo-600/10"
      aria-hidden
    />
  </>
);

export const fairtradeDarkControlClass = cn(
  'rounded-xl border border-solid border-[#1a2f5c] bg-[#01012e]',
  'shadow-[inset_0_1px_0_rgba(255,255,255,0.03)]',
  'outline-none ring-0',
  'transition-[border-color,box-shadow,background-color] duration-200',
  'hover:border-sky-400/35 hover:bg-[#030023]',
  'focus:border-sky-400/45 focus:bg-[#030023] focus:ring-2 focus:ring-sky-400/15',
  'focus-visible:outline-none',
  '[color-scheme:dark]'
);

export const fairtradeDarkInputClass = cn(
  fairtradeDarkControlClass,
  'appearance-none',
  '[&::-webkit-search-cancel-button]:hidden [&::-webkit-search-decoration]:hidden'
);

export const fairtradeDarkMenuClass = cn(
  'overflow-hidden rounded-xl border border-solid border-[#1a2f5c] bg-[#030023]',
  'shadow-xl shadow-black/45 ring-1 ring-sky-400/15'
);

export const fairtradeDarkChipClass = cn(
  'rounded-full border px-3 py-1.5 font-poppins text-xs font-semibold transition-all duration-200'
);

export const fairtradeDarkChipInactiveClass = cn(
  'border-blue-900/60 bg-[#030023]/45 text-blue-100/80',
  'hover:border-sky-400/35 hover:bg-blue-950/50 hover:text-blue-50'
);

export const fairtradeDarkChipActiveClass = cn(
  'border-sky-400/40 bg-sky-400/15 text-sky-100 ring-1 ring-sky-400/25'
);

export const fairtradeDarkDividerClass = 'border-blue-900/50';

type FairtradeDarkPanelShellProps = {
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
  id?: string;
};

export function FairtradeDarkPanelShell({
  children,
  className,
  innerClassName,
  id,
}: FairtradeDarkPanelShellProps) {
  return (
    <div id={id} className={cn(fairtradeDarkPanelShellClass, className)}>
      {fairtradeDarkPanelGradientLayers}
      <div className={cn('relative z-10', innerClassName)}>{children}</div>
    </div>
  );
}
